import { LoadingScreen } from '@/features/common/components/LoadingScreen';
import { setupInterceptors } from '@/services/api/_axios-instance';
import { useAuth0 } from '@auth0/auth0-react';
import { PropsWithChildren, useEffect, useState } from 'react';

const SetupAxios = ({ children }: PropsWithChildren) => {
  const { getAccessTokenSilently, isLoading } = useAuth0();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (isLoading) return;

    const { clear } = setupInterceptors(getAccessTokenSilently);
    setLoaded(true);

    return () => {
      clear();
    };
  }, [getAccessTokenSilently, isLoading]);

  return loaded ? children : <LoadingScreen />;
};

export default SetupAxios;
